<template>
    <div id="landing-app" style="opacity: 0;">
        <div class="header">
            <div class="background">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="background-rvs"></div>
            <div class="inner">
                <Navbar></Navbar>
                <intro-chapter></intro-chapter>
            </div>
        </div>
        <div class="body">
            <div class="inner">
                <engine-chapter></engine-chapter>
                <feature-chapter></feature-chapter>
                <author-chapter></author-chapter>
                <developer-chapter></developer-chapter>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from './Navbar.vue'
import IntroChapter from './IntroChapter.vue'
import EngineChapter from './EngineChapter.vue'
import FeatureChapter from './FeatureChapter.vue'
import AuthorChapter from './AuthorChapter.vue'
import DeveloperChapter from './DeveloperChapter.vue'

export default {
    components: {
        Navbar,
        IntroChapter,
        EngineChapter,
        FeatureChapter,
        AuthorChapter,
        DeveloperChapter,
    },
}
</script>


<style lang="less">
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #f7f9fc !important;
}
body #landing-app {
    -webkit-transition: 0.4s all;
    -o-transition: 0.4s all;
    transition: 0.4s all;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>
<style lang="less">
@media (max-width: 767px) {
    .landing-navbar-base {
        display: none;
    }
    #landing-app {
        padding-top: 60px;
        .header {
            height: 600px !important;
        }
    }
}
#landing-app {
    opacity: 1 !important;
    .header {
        height: 760px;
        position: relative;
        top: -80px;
    }
    .container {
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        position: relative;
        @media (min-width: 768px) {
            width:750px
        }
        @media (min-width: 992px) {
            width:970px
        }
        @media (min-width: 1200px) {
            width:1170px
        }
    }
    .body {
        position: relative;
        margin-top: -300px;
    }
}
</style>
<style lang="less" scoped>
.background-image-icon {
    position: absolute;
    pointer-events: none;
    -webkit-filter: brightness(0) invert(1);
            filter: brightness(0) invert(1);
    opacity: 0.7;
}
.background-rvs {
    top: 0;
    position: absolute;
    z-index: -1;
    width: 100%;
    -webkit-transform: skewY(-12deg);
            transform: skewY(-12deg);
    -webkit-transform-origin: 0%;
            transform-origin: 0%;
    background: white;
    @media (min-width: 1750px) {
        height: 1220px !important;
    }
    @media (min-width: 1200px) {
        height: 1150px;
    }
    @media (max-width: 1199px) and (min-width: 992px) {
        height: 1130px;
    }
    @media (max-width: 991px) and (min-width: 768px) {
        height: 1070px;
    }
    @media (max-width: 767px) {
        height: 990px;
    }
     * {
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    }
}
.background {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-transform: skewY(12deg);
            transform: skewY(12deg);
    -webkit-transform-origin: 100%;
            transform-origin: 100%;
    background: -o-linear-gradient(240deg, #222222 15%, #373737 70%, #3c4859 94%);
    background: linear-gradient(-150deg, #222222 15%, #373737 70%, #3c4859 94%);
     * {
        -webkit-box-sizing: border-box;
                box-sizing: border-box;
    }
    @media (max-width: 767px) {
        span {
            opacity: 0;
        }
    }
    span {
        -webkit-transition: 0.4s all;
        -o-transition: 0.4s all;
        transition: 0.4s all;
        position: absolute;
        height: 190px;
        width: 33.33333%;
    }
    span:nth-child(1) {
        display: none;
        top: 0;
        right: -16.66666%;
        background: #373737;
    }
    .background span:nth-child(2) {
        top: 0;
        right: 16.66666%;
        left: auto;
        bottom: auto;
        background: #2e2e2e;
    }
    span:nth-child(3) {
        right: 49.99999%;
        bottom: auto;
        left: auto;
        background: #222222;
    }
    span:nth-child(4) {
        top: 380px;
        left: -16.66666%;
        background: #383d44;
    }
    span:nth-child(5) {
        right: 0;
        bottom: 0;
        background: #2e2e2e;
    }
}
</style>
<style lang="less">
@font-face {
    font-family: TypoRound;
    font-weight: normal;
    src: url(https://h5mota.com/assets/Typo_Round_Regular.1a899395b.otf) format('opentype');
}
#landing-app {
    h1 {
        font-weight: 500;
        font-size: 40px;
        color: white;
    }
    h2 {
        color: #1da09c;
        font-weight: 500;
        font-size: 22px;
        margin-top: 10px;
        margin-bottom: 20px;
        line-height: 1.5em;
    }
    a {
        text-decoration: none;
    }
    p.link {
        margin-top: 15px;
        opacity: 1 !important;
        cursor: pointer;
        color: #0088cc;
        :hover {
            color: #3fbbff;
        }
    }
    p {
        margin-top: 15px;
        margin: auto;
        max-width: 600px;
        font-weight: 400;
        font-size: 15px;
        line-height: 1.9em;
        letter-spacing: 0.03em;
    }
    .content p {
        opacity: 0.5;
        font-weight: 400;
    }
    .h5mota {
        font-family: TypoRound, sans-serif;
    }
}
</style>